import _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { APP_CONFIG } from 'src/app/app.const';
import { AdminService } from '../admin.service';
import { CommonModule, DatePipe } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { QatchComponent } from 'src/app/components/qatch.component';
import { Debounce } from 'src/app/shared/decorators/debounce.decorator';
import { ComponentsModule } from 'src/app/components/components.module';
import { ToastService, UikitBreadcrumbComponent } from '@hss-m/uikit-common';
import { FiltersModule } from 'src/app/shared/modules/filters/filters.module';
import { UikitFormModule } from 'src/app/shared/modules/uikit-form/uikit-form.module';
import { getErrorMsg } from '../../common/components/dashboard-layout/dashboard.const';
import { BarChartOptions, Colors, DoughnutChartOptions, SUMMARY_FILTERS } from './config.const';
import { DataViewTableModule } from 'src/app/shared/modules/data-view-table/data-view-table.module';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    FiltersModule,
    DataViewTableModule,
    ComponentsModule,
    ChartModule,
    UikitFormModule,
    UikitBreadcrumbComponent,
  ],
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  providers: [ ToastService ]
})
export class SummaryComponent extends QatchComponent implements OnInit {

  activities = [];
  filtered = {};
  ploading: boolean = true;
  cloading: boolean = true;
  monthlyUserGrowth: any;
  overallUserGrowth: any;
  userSummaryPerUtmChannel: any;
  barChartOptions: any = BarChartOptions;
  doughnutChartOptions: any = DoughnutChartOptions;
  doughnutChartHeight: string;

  constructor(
    protected override authService: AuthService,
    protected override deviceService: DeviceDetectorService,
    private readonly adminService: AdminService,
    private toastService: ToastService,
    private datePipe: DatePipe
  ) {
    super(deviceService, authService);
    this.filters = SUMMARY_FILTERS(this);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.getFilterData();
  }

  getFilterData() {
    const appFilters = this.filters.filter(i => i.filterId).map(i => i);
    this.adminService.getFilters([...appFilters])
      .subscribe(({ filters }: any) => {
        this.filters = _.cloneDeep(this.filters.map(filter => {
          if (filter.filterId) {
            filter.data = filters[filter.filterId];
          }
          return filter;
        }));
      });
  }

  getFilters() {
    let searchString = '';
    return {
      ...this.filtered,
      searchString
    }
  }

  getSummary() {
    this.ploading = true;
    this.adminService.summary(this.filtered).subscribe({
      next: (resp: any) => {
        this.ploading = false;
        this.cloading = false;
        this.showUserSummary(resp.users_summary);
        this.prepareBarChartsData(resp);
        this.prepareUtmSummaryChartData(resp.users_summary_per_utm_channels);
      },
      error: (error: any) => {
        this.ploading = false;
        this.cloading = false;
        const message = getErrorMsg(error);
        this.toastService.error({message});
      }
    });
  }

  showUserSummary(users_summary: any) {
    this.activities = [];
    for (const key in users_summary) {
      const value = users_summary[key];
      this.activities.push({
        heading: key.split('_').join(' '),
        key: value || 0,
        icon: "bi bi-people-fill"
      });
    }
  }

  prepareUtmSummaryChartData(utmSummary: any) {
    if (!utmSummary || !utmSummary.length) {
      this.userSummaryPerUtmChannel = null;
      return;
    }
    const data = [], labels = [], backgroundColors = [];
    utmSummary.forEach((row: any, index: number) => {
      data.push(row.users);
      labels.push(row.utm_channel);
      backgroundColors.push(Colors[index % Colors.length])
    })
    this.userSummaryPerUtmChannel = {
      datasets: [{
        data: data,
        backgroundColor: backgroundColors,
        label: 'Users'
      }],
      labels: labels
    };
    this.doughnutChartHeight = data.length < 6 ? '200px' : '500px';
  }

  prepareBarChartsData(resp: any) {
    if (this.monthlyUserGrowth || !resp.users_monthly_summary || !resp.users_monthly_summary.length) return; // Dont' re-render after filter changes
    const monthLabels = [];
    const monthlyUserGrowthData = [];
    const overallUserGrowthData = [];
    const totalUsers = resp.users_total_count;
    let sum = 0;
    resp.users_monthly_summary.forEach((row: any) => {
      overallUserGrowthData.push(totalUsers - sum);
      sum += parseInt(row.users);
    });
    resp.users_monthly_summary.reverse().forEach((row: any) => {
      monthLabels.push(this.toMonthLabel(row));
      monthlyUserGrowthData.push(row.users);
    });
    this.monthlyUserGrowth = {
      labels: monthLabels,
      datasets: [
        {
          label: 'Monthly User Growth',
          backgroundColor: '#42A5F5',
          data: monthlyUserGrowthData
        }
      ]
    };
    this.overallUserGrowth = {
      labels: monthLabels,
      datasets: [
        {
          label: 'Overall User Growth',
          backgroundColor: '#42A5F5',
          data: overallUserGrowthData.reverse()
        }
      ]
    };
  }

  toMonthLabel(row: any) {
    const date = new Date();
    date.setMonth(parseInt(row.txn_month) - 1);
    date.setFullYear(parseInt(row.txn_year));
    return this.datePipe.transform(date, 'MMM-yy');
  }

  @Debounce(APP_CONFIG.DEBOUNCE_INTERVAL)
  onFilterValueChange() {
    this.getSummary();
  }
}